<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">wb_cloudy</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">Over Due Vendors {{ title }}</span>
					<ng-content select="[vendordash-asof-label]"></ng-content>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="sending || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="sending || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="vd-toolbar-row">
					<div class="vd-search">
						<input class="vd-search__input" type="text" placeholder="Search vendor" [(ngModel)]="searchTerm" aria-label="Search vendor">
						<i class="material-icons vd-search__icon" aria-hidden="true">search</i>
					</div>
					<span class="vd-count-pill">{{ displayRows.length }} vendors</span>
				</div>

				<div class="vd-table-wrap" #print_table>
					<table class="vd-table table">
						<thead class="thead-dark">
							<tr>
								<th class="vd-th vd-col-id vd-sortable" (click)="sortBy('supplierid')">
									ID <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('supplierid') }}</i>
								</th>
								<th class="vd-th vd-sortable" (click)="sortBy('suppname')">
									Vendor <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('suppname') }}</i>
								</th>
								<th class="vd-th d-none d-lg-table-cell">Terms</th>
								<th class="vd-th text-right vd-sortable" (click)="sortBy('balance')">
									Balance <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('balance') }}</i>
								</th>
								<th class="vd-th text-right d-none d-md-table-cell vd-sortable" (click)="sortBy('overdue')">
									30 Day <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('overdue') }}</i>
								</th>
								<th class="vd-th text-right d-none d-lg-table-cell vd-sortable" (click)="sortBy('overdue1')">
									60 Day <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('overdue1') }}</i>
								</th>
								<th class="vd-th text-right d-none d-lg-table-cell vd-sortable" (click)="sortBy('overdue2')">
									90 Day <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('overdue2') }}</i>
								</th>
								<th class="vd-th text-right vd-col-due vd-sortable" (click)="sortBy('due')">
									Past Due <i class="material-icons vd-sort-icon" aria-hidden="true">{{ getSortIcon('due') }}</i>
								</th>
								<th class="vd-th vd-col-actions vd-pay-cell"></th>
							</tr>
						</thead>

						<tbody>
							<ng-container *ngFor="let v of displayRows">
								<tr class="vd-row" [class.vd-row--open]="expandedRow === v" (click)="toggleDetails(v)">
									<td class="vd-cell d-none d-sm-table-cell">
										<span class="vd-id-badge">{{ v.supplierid }}</span>
									</td>
									<td class="vd-cell">
										<span class="vd-vendor-name">{{ v.suppname }}</span>
										<span class="vd-id-xs d-inline d-sm-none text-muted">&nbsp;#{{ v.supplierid }}</span>
									</td>
									<td class="vd-cell d-none d-lg-table-cell text-muted">{{ v.terms }}</td>
									<td class="vd-cell text-right vd-num">{{ toNum(v.balance) | currency }}</td>
									<td class="vd-cell text-right vd-num d-none d-md-table-cell">
										<span *ngIf="toNum(v.overdue) > 0">{{ toNum(v.overdue) | currency }}</span>
										<span class="text-muted" *ngIf="toNum(v.overdue) <= 0">—</span>
									</td>
									<td class="vd-cell text-right vd-num vd-num--warn d-none d-lg-table-cell">
										<span *ngIf="toNum(v.overdue1) > 0">{{ toNum(v.overdue1) | currency }}</span>
										<span class="text-muted" *ngIf="toNum(v.overdue1) <= 0">—</span>
									</td>
									<td class="vd-cell text-right vd-num vd-num--late d-none d-lg-table-cell">
										<span *ngIf="toNum(v.overdue2) > 0">{{ toNum(v.overdue2) | currency }}</span>
										<span class="text-muted" *ngIf="toNum(v.overdue2) <= 0">—</span>
									</td>
									<td class="vd-cell text-right vd-col-due">
										<span class="vd-due-amount" [class.vd-due-amount--zero]="toNum(v.due) <= 0">
											{{ toNum(v.due) | currency }}
										</span>
									</td>
									<td class="vd-cell vd-col-actions vd-pay-cell" (click)="$event.stopPropagation()">
										<button mat-icon-button class="vd-action-btn"
											[matTooltip]="expandedRow === v ? 'Collapse' : 'Details'"
											[attr.aria-label]="'Show open invoices for ' + v.suppname"
											(click)="toggleDetails(v)">
											<mat-icon>{{ expandedRow === v ? 'expand_less' : 'expand_more' }}</mat-icon>
										</button>
										<button mat-icon-button class="vd-action-btn vd-action-btn--pay"
											matTooltip="Pay / Allocate"
											[attr.aria-label]="'Pay ' + v.suppname"
											(click)="openPaymentModal(v)">
											<mat-icon>payment</mat-icon>
										</button>
									</td>
								</tr>

								<!-- Detail panel: open AP transactions, same idiom as brand disbursements -->
								<tr *ngIf="expandedRow === v" class="vd-detail-row">
									<td colspan="9" class="vd-detail-cell">
										<div class="vd-detail-panel">
											<div class="vd-detail-panel__header">
												<mat-icon class="vd-detail-panel__icon">receipt_long</mat-icon>
												<span class="vd-detail-panel__name">{{ v.suppname }}</span>
												<span class="vd-detail-panel__id">#{{ v.supplierid }}</span>
												<button mat-flat-button color="accent" class="vd-detail-pay-btn" (click)="openPaymentModal(v)">
													<mat-icon>payment</mat-icon>
													Pay {{ toNum(v.due) | currency }}
												</button>
											</div>

											<div class="vd-stat-grid">
												<div class="vd-stat">
													<span class="vd-stat__label">Balance</span>
													<span class="vd-stat__value">{{ toNum(v.balance) | currency }}</span>
												</div>
												<div class="vd-stat">
													<span class="vd-stat__label">Past Due</span>
													<span class="vd-stat__value vd-stat__value--due">{{ toNum(v.due) | currency }}</span>
												</div>
												<div class="vd-stat">
													<span class="vd-stat__label">60 Day</span>
													<span class="vd-stat__value vd-stat__value--warn">{{ toNum(v.overdue1) | currency }}</span>
												</div>
												<div class="vd-stat">
													<span class="vd-stat__label">90 Day</span>
													<span class="vd-stat__value vd-stat__value--late">{{ toNum(v.overdue2) | currency }}</span>
												</div>
											</div>

											<div class="vd-invoice-detail">
												<div class="vd-section-label">
													<mat-icon class="vd-section-label__icon">description</mat-icon>
													Open AP Transactions
												</div>

												<div *ngIf="detailLoading" class="text-center text-muted py-3">
													<svg class="spinner" width="24px" height="24px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
														<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
													</svg>
												</div>

												<ng-container *ngIf="!detailLoading">
													<div *ngIf="!detailRows.length" class="text-muted small py-2 px-3">No open transactions found.</div>
													<div class="table-responsive" *ngIf="detailRows.length">
														<table class="table table-sm vd-inv-table mb-0">
															<thead>
																<tr>
																	<th>Type</th>
																	<th>Doc #</th>
																	<th>Date</th>
																	<th>Due Date</th>
																	<th>Reference</th>
																	<th class="text-right">Total</th>
																	<th class="text-right">Open</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let t of detailRows">
																	<td>{{ t.typename }}</td>
																	<td>{{ t.transno }}</td>
																	<td class="text-muted small">{{ t.trandate }}</td>
																	<td class="text-muted small">{{ t.duedate || '—' }}</td>
																	<td class="text-muted small">
																		{{ t.suppreference || '—' }}
																		<span class="d-block vd-subline" *ngIf="t.ordernos">PO {{ t.ordernos }}</span>
																	</td>
																	<td class="text-right vd-num">{{ toNum(t.totalamount) | number:'1.2-2' }}</td>
																	<td class="text-right vd-num">{{ toNum(t.balance) | number:'1.2-2' }}</td>
																</tr>
															</tbody>
														</table>
													</div>
												</ng-container>
											</div>
										</div>
									</td>
								</tr>
							</ng-container>

							<tr *ngIf="!displayRows.length" class="vd-empty-row">
								<td colspan="9">
									<div class="vd-empty">
										<mat-icon class="vd-empty__icon">search_off</mat-icon>
										<span>{{ searchTerm ? 'No vendors match your search' : 'Nobody is overdue 🎉' }}</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="Over Due Vendors"
				icon="wb_cloudy"
				accent="info"
				[value]="total_overdue_details?.total"
				[loading]="!aged"
				[showView]="!!aged"
				[buckets]="overdueBuckets"
				(bucketView)="onOverdueBucket($event)"
				(view)="toggleFlip(original_aged, 'All')">
				<div dscHeaderExtra class="vendordash-overdue-header-toolbar">
					<ng-content select="[vendordash-asof-toolbar]"></ng-content>
				</div>
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
